import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericAbsService } from '../utils/generic-abs-service';
import { AbdaliModuleConfig, moduleConfigToken } from '../app.module';
import { ApiResponse, CategoryDto } from '../objects';

@Injectable()
export class CategoryService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken)private moduleConfig: AbdaliModuleConfig, private http: HttpClient) {
        super(moduleConfig.baseUrl, http);
    }

    getCategories(endpoint?: string, name?: string, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/category' : endpoint;
        endpoint = (name != null ? `${endpoint}?name=${name}` : endpoint);
        return this.getAll(endpoint, headers);
    }

    getCategoryById(endpoint: string = null, id: number, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/category' : endpoint;
        return this.getById(endpoint, id, headers);
    }

    insert(endpoint: string = null, dto: CategoryDto, file: File, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/category' : endpoint;
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }

        dto.description = dto.description == null ? '' : dto.description;
        dto.name = dto.name == null ? '' : dto.name;

        const formData = new FormData();
        formData.append('name', dto.name);
        formData.append('description', dto.description);
        formData.append('searchField', dto.searchField.toString());
        if (file) {
            formData.append('files', file, file.name);
        }

        return this.post(endpoint, formData, headers);
    }

    update(endpoint: string = null, dto: CategoryDto, file: File, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/category' : endpoint;
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }

        dto.description = dto.description == null ? '' : dto.description;
        dto.name = dto.name == null ? '' : dto.name;

        const formData = new FormData();
        formData.append('id', dto.id.toString());
        formData.append('name', dto.name);
        formData.append('description', dto.description);
        formData.append('searchField', dto.searchField.toString());
        if (file) {
            formData.append('files', file, file.name);
        }

        return this.put(endpoint, formData, headers);
    }
}
